import { render } from "./SubCancelSurveys.vue?vue&type=template&id=7620a351"
import script from "./SubCancelSurveys.vue?vue&type=script&lang=js"
export * from "./SubCancelSurveys.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__